export type Theme = "light" | "dark";
const KEY = "orator.theme";
export function initTheme() {
  const saved = (localStorage.getItem(KEY) as Theme) || "light";
  document.documentElement.dataset.theme = saved;
}
export function toggleTheme(): Theme {
  const next: Theme = document.documentElement.dataset.theme === "dark" ? "light" : "dark";
  document.documentElement.dataset.theme = next;
  localStorage.setItem(KEY, next);
  return next;
}
export function currentTheme(): Theme {
  return (document.documentElement.dataset.theme as Theme) || "light";
}
